// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/admin_customer",
    element: lazy(() => import("../pages/CustomerTemplate")),
  },
  {
    path: "/admin_customer/add",
    element: lazy(() => import("../pages/CustomerTemplate//AddEditCustomer")),
  },
  {
    path: "/admin_customer/edit/:customerId",
    element: lazy(() => import("../pages/CustomerTemplate//AddEditCustomer")),
  },
  {
    path: "/admin_customer/view/:customerId",
    element: lazy(() => import("../pages/CustomerTemplate/CustomerView")),
  },
  {
    path: "/admin_customer/vieworder/:customerId",
    element: lazy(() => import("../pages/CustomerTemplate/CustomerOrder")),
  },
  {
    path: "/admin_customer/vieworderitem/:orderId",
    element: lazy(() => import("../pages/CustomerTemplate/CustomerOrderItem")),
  },
];

export default routes;
